import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-project-placeholder',
  templateUrl: './project-placeholder.component.html',
  styleUrls: ['./project-placeholder.component.scss']
})
export class ProjectPlaceholderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
